import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
const moment = require("moment");
const HiddenField = (props) => {
  const { default_value, name, setSelectedData,is_conditional,selectedData,keys_to_consider,options_type} = props;

  const dispatch = useDispatch();
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const allOptionList = useSelector((state) => state.staticData?.allOptionList);
  const uploadedDocument = useSelector((state)=>state?.uploadDocumentReducer);
  const context = useMemo(() => ({ uploadedDocument }), [uploadedDocument]);

  const computedValue = useMemo(() => {
    if (typeof default_value === 'string' && default_value?.includes('uploadedDocument')) {
      return eval(default_value);
    }
    return default_value;
  }, [default_value, context]);

  useEffect(() => {
    if(default_value){
    if (default_value && default_value == "current_date") {
      const currentDate =  moment().format("DD-MM-YYYY");
      dispatch(
        setSelectedData({
          key: [`${name}`],
          value: currentDate,
        })
      );
    } else {
      dispatch(
        setSelectedData({
          key: [`${name}`],
          value: is_conditional ?  eval(default_value) : default_value,
        })
      );
    }
  }
  }, [default_value, dispatch, name, setSelectedData,computedValue]);

  const dependencyValues = useMemo(() => {
    return keys_to_consider?.map((key) => selectedData[key]);
  }, [keys_to_consider, selectedData]);

  const getFilteredOptions = (keysToConsider,optionKey) =>{
    let obj = keysToConsider?.reduce((acc, item) => {
      acc[item] = selectedData[item];
      return acc;
    }, {})
    if(obj){
    const filteredData = allOptionList?.filter((item) =>
      Object.entries(obj).every(([key, value]) => value !== undefined && item[key] === value)
  );  
  let optionArray = filteredData?.map((item) => item?.[optionKey]).filter((value) => value !== undefined); 
     optionArray = [...new Set(optionArray)]
      return optionArray;
  }
}

  useEffect(() => {
    if (options_type === "autofill") {
      let filteredData = getFilteredOptions(keys_to_consider, name);
      if (filteredData.length === 1 && selectedData[name] !== filteredData[0]) {
        dispatch(setSelectedData({ key: name, value: filteredData[0] }));
      }
    }
  }, [options_type, dependencyValues, name, dispatch])


  return null;
};

export default HiddenField;
